module.exports = __webpack_public_path__ + "img/ch57.e0155f6b.jpg";